import React, { Component } from 'react'
import {PieChart, Pie} from 'recharts';
import {calculateColor} from '../Animations/helper'

class ConditionsChart extends Component {

    static propTypes = {
        fatigue: React.PropTypes.number.isRequired
    }

    shouldComponentUpdate(nextProps, nextState) {
        return nextProps.fatigue != this.props.fatigue;
    }
	
	render() {
        if(this.props.fatigue == null)
            return null;
        
        let startAngle = this.calculateStartAngle(this.props.fatigue);
        let endAngle = this.calculateEndAngle(startAngle, this.props.fatigue);
        
        return (<PieChart width={16} height={16}>
                <Pie dataKey={'name'} strokeWidth={0} isAnimationActive={false} startAngle={startAngle} endAngle={endAngle} data={[{name: 8, value: 100}, {value: 0}]} 
                    innerRadius={4} outerRadius={8} fill={calculateColor(this.props.fatigue)}
                />
            </PieChart>);
    }

    calculateStartAngle(fatigue) {
        return 90 + (fatigue) / (8) * 360;
    }
    
    calculateEndAngle(startAngle, fatigue) {
        return startAngle + (8 - fatigue) / (8) * 360;
    }
}

export default ConditionsChart


/** WEBPACK FOOTER **
 ** ./src/components/PopupStats/ConditionsChart.js
 **/